import { Mixins, Component, VModel, Prop, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import { Debounce } from 'lodash-decorators'

import Authentication from '@/views/Authentication/models/authentication'

@Component({
    inheritAttrs: false,
})
export default class PasswordInput extends Mixins<MixinInterface>() {
    @Prop({ required: true }) userId!: string
    @VModel() password!: string | null

    visible = false

    validators: any = null

    @Debounce(300)
    @Watch('password')
    async checkPassword() {
        if (this.password && this.userId) {
            this.validators = await Authentication.checkPasswordStrength(this.password, this.userId)
        }
        if (!this.password) {
            this.validators = null
        }
    }

    // LIFESYCLE
    async mounted() {
        await Authentication.getPasswordRequirements()
    }
}
